<template>
  <ion-img
    v-if="src !== undefined"
    :src="imgPath"
  />
</template>

<script>
import {IonImg} from '@ionic/vue';

export default {
    components: {
        IonImg,
    },
    props: {
        src: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        imgPath() {
            const img = this.$store.getters.image(this.src);
            if (img === undefined) {
                this.$store.dispatch('loadImage', {fileName: this.src});
            }
            return img;
        },
    },
    mounted() {
        this.$store.dispatch('loadImage', {fileName: this.src});
    },
    methods: {
    },
};
</script>
